// Revoke-session wiring for the sign-out machine. Kept free of app imports so the
// failure and invalidation behaviour can be tested without mounting BootManager.
export function createRevokeSessionHandlers(deps: {
  revoke: (sessionId: string) => Promise<unknown>;
  invalidateSessions: () => void;
  notifyRevokeFailed: () => void;
}) {
  return {
    // A rejected `revoke` must reject here: the machine uses that to take the error path.
    onRevokeSession: async (sessionId: string) => {
      await deps.revoke(sessionId);
    },
    // The session list is a separate query; without this it keeps showing a device
    // that no longer exists until the user presses «Refresh».
    onRevokeSuccess: () => {
      deps.invalidateSessions();
    },
    onRevokeError: () => {
      deps.notifyRevokeFailed();
    },
  };
}
